/**
 * Utility functions for URL handling
 */

// Get the base URL for the application
export const getBaseUrl = (subdomain) => {
  if (!subdomain) {
    return '/';
  }
  // For local development, we use /subdomain/ format
  return `/${subdomain}/`;
};

// Get the admin URL for the application
export const getAdminUrl = (subdomain) => {
  if (!subdomain) {
    return '/admin';
  }
  // For local development, we use /subdomain/admin/ format
  return `/${subdomain}/admin`;
};

// Get the public URL for viewing a menu
export const getMenuUrl = (subdomain, menuId) => {
  const baseUrl = getBaseUrl(subdomain);
  if (menuId) {
    return `${baseUrl}menu/${menuId}`;
  }
  return `${baseUrl}menu`;
};

// Get the URL for a specific page
export const getPageUrl = (subdomain, page) => {
  const baseUrl = getBaseUrl(subdomain);
  return `${baseUrl}${page}`;
};

// Parse subdomain from pathname
export const parseSubdomain = (pathname) => {
  // For local development, subdomain is the first segment of the path
  // e.g., /school/admin/... -> school
  if (pathname && pathname.startsWith('/')) {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length > 0) {
      return segments[0];
    }
  }
  return '';
};

// Get a URL for the menu editor
export const getMenuEditorUrl = (subdomain, menuId = null, queryParams = {}) => {
  console.log(`[MenuTypeDebug] getMenuEditorUrl called with: subdomain=${subdomain}, menuId=${menuId}, queryParams=`, queryParams);
  
  const adminUrl = getAdminUrl(subdomain);
  const baseUrl = menuId ? `${adminUrl}/menu-editor/${menuId}` : `${adminUrl}/menu-editor`;
  console.log(`[MenuTypeDebug] Base URL constructed: ${baseUrl}`);
  
  // Add query parameters if provided
  if (Object.keys(queryParams).length > 0) {
    console.log(`[MenuTypeDebug] Adding query parameters:`, queryParams);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        console.log(`[MenuTypeDebug] Adding param: ${key}=${value} (${typeof value})`);
        searchParams.append(key, value);
      } else {
        console.log(`[MenuTypeDebug] Skipping null/undefined param: ${key}`);
      }
    });
    
    const queryString = searchParams.toString();
    if (queryString) {
      const fullUrl = `${baseUrl}?${queryString}`;
      console.log(`[MenuTypeDebug] Final URL with query params: ${fullUrl}`);
      return fullUrl;
    }
  }
  
  console.log(`[MenuTypeDebug] Returning URL without query params: ${baseUrl}`);
  return baseUrl;
};

export default {
  getBaseUrl,
  getAdminUrl,
  getMenuUrl,
  getPageUrl,
  parseSubdomain,
  getMenuEditorUrl
}; 